export const PAGINATION_TYPE = {
  NAVIGATION: 'NAVIGATION',
  SCROLLABLE: 'SCROLLABLE'
};
